import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import { Avatar, Tooltip } from '@nextui-org/react';
import { Popover, Table, Text } from '@nextui-org/react';
import { useMountEffect } from 'primereact/hooks';
import { Messages } from 'primereact/messages';
import { Message } from 'primereact/message';
import { Badge } from "@nextui-org/react";

import { Button } from 'primereact/button';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { infoStyle, cardStyle, cardHeaderStyle, infoOutlineStyle } from "./TileStyles";

import { formatTokenLabel, formatPercentage, abbreviateNumber, getTokenPrice, formatTokenIcon, getTokenLogo, chunkArray } from '../../utils';

import BigNumber from 'bignumber.js';

const RewardPacksModuleProfile = ({ data, getData, currentProfile }) => {

    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;

    const LoadingContent = () => <Skeleton shape="circle" width="50%" height="35px" className="mb-2" />;

    // const msgs = useRef(null);
    // useMountEffect(() => {
    //     msgs.current.show([
    //         { sticky: true, severity: 'warn', detail: 'You have a reward pending distribution, changing your profile at this moment will result in loss of accumulated rewards',},
    //     ]);
    // });

    const bnbPendingLiquidation = () => {
        if (!data?.contractDataRp?.smartData?.subscriptionPools) return 0;

        let total = 0;
        for (const poolID of data?.contractDataRp?.smartData.subscriptionPools) {
            const currentTokenData = data?.tokenPoolDataRp?.find((token) => token._poolID === poolID, 10);
            if (currentTokenData && !isNaN(currentTokenData._bnbPending) && currentTokenData._bnbPending > 0) {
                total += 1;
            }
        }

        return total;
    };

    const calculateTotalWeight = () => {
        if (!currentProfile) return 1;
        let totalWeight = 0;
        Object.values(currentProfile).forEach(weight => {
            totalWeight += parseFloat(weight);
        });
        //console.log('totalWeight: ', totalWeight);
        return totalWeight;
    };


    return (
        <>
            <Card title={<div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '0.85rem',
                fontWeight: '200',
                color: 'grey',
            }}>YOUR REWARD PACK

            </div>
            }
                style={{
                    ...cardStyle,
                    //hide box shadow
                    boxShadow: "none",
                }}>
                <div style={infoStyle}>
                    {data?.contractDataRp?.smartData
                        ? data.contractDataRp.smartData.subscriptionPools
                            ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '15px' }}>
                                {chunkArray(data?.contractDataRp?.smartData.subscriptionPools, 5).map((chunk, rowIndex) => (
                                    <div key={rowIndex} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                                        {chunk.map((poolID, index) => {
                                            const currentTokenInfo = data?.dbData?.find((token) => parseInt(token.poolId, 10) === parseInt(poolID, 10));
                                            const currentLogoUrl = getTokenLogo(data?.dbData, currentTokenInfo);
                                            const currentTokenData = data?.tokenPoolDataRp?.find((token) => token._poolID === poolID, 10);
                                            const tokenAddress = currentTokenData?._tokenAddress?.toLowerCase();

                                            return (currentTokenData &&
                                                <React.Fragment key={index}>
                                                    <span style={{ marginLeft: '2px', marginRight: '2px' }}>
                                                        <Badge disableOutline content={
                                                            currentProfile && parseInt(currentProfile[tokenAddress]) > 0 ? (parseInt(currentProfile[tokenAddress]) / calculateTotalWeight() * 100).toFixed(0) + '%' : 0
                                                        } size="xs">
                                                            <Avatar
                                                                size="lg"
                                                                pointer
                                                                src={currentLogoUrl}
                                                                bordered
                                                                color={currentTokenData._unclaimedAmount > 0 ? "warning" : "gradient"}
                                                                onClick={(e) => { }}
                                                            />
                                                        </Badge>
                                                    </span>
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                            : "None"
                        : <Skeleton width="100%" height="50px" className="mb-2" />}


                    {calculateTotalWeight() == 0 && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                        <Message severity="warn" text={"Reward Pack is inactive."} />
                    </div>}


                </div>


            </Card >
            {/* {bnbPendingLiquidation() > 0 && (data?.contractDataRp?.tokenData?.rocketFiBalance > 0 || data?.contractDataRp?.burnData?.rocketFuelAmount > 0) && <Messages ref={msgs} />} */}

        </>
    );
}

export default RewardPacksModuleProfile;

